import { createContext, createRef, useContext } from 'react';
export const MentionContext = /*#__PURE__*/ createContext({
    editorContainerRef: /*#__PURE__*/ createRef(),
    getMentionSuggestions: ()=>Promise.resolve([])
});
export const MentionProvider = MentionContext.Provider;
export function useMentionContext() {
    return useContext(MentionContext);
}
